<template>
  <div class="unsign">
    <div class="block" v-if="show">
      <van-cell-group>
        <van-cell>
          <div class="flex">
            <span
              style="
                color: rgba(153, 159, 164, 100);
                font-family: SourceHanSansSC-bold;
              "
              >客户告知书</span
            >
            <div class="signbtn" :class="{ bg59: data.isFinished }" v-if="data.isFinished">
              {{ data.isFinished ? "已签名" : "未签名" }}
            </div>
          </div>
        </van-cell>
        <van-cell
          title="客户姓名"
          :value="data.customerName"
          value-class="label"
        />
        <van-cell
          title="手机号"
          :value="data.mobile"
          value-class="label"
          v-if="cansign == 1"
        />
        <van-cell
          title="身份证号码"
          :value="data.idNo"
          value-class="label"
           v-if="cansign == 1"
        />
        <van-cell title="产品名称" :value="data.product" value-class="label" />
        <van-cell title="保险公司" :value="data.company" value-class="label" />
        <van-cell title="客户告知书">
          <div class="flex" style="justify-content: flex-end">
            <span class="pdf" @click="topreview">{{!data.isFinished?'预览':'查看'}}</span>
            <div
              v-if="!data.isFinished && cansign != 1"
              class="tosign"
              @click="tosign"
            >
              点此签名
            </div>
          </div>
        </van-cell>
      </van-cell-group>
      <van-button
        type="primary"
        block
        color="#31D5BF"
        round
        class="keep"
        v-if="!data.isFinished && cansign != 1"
        @click="sign"
        >提交</van-button
      >
           <!-- @click="showimg" -->
      <van-button
        type="primary"
        block
        color="#31D5BF"
        round
        class="keep"
        v-clipboard:success="onCopy"
        v-clipboard:copy="href"
         v-clipboard:error="onError"
        v-else-if="!data.isFinished"
   
        >分享给客户</van-button
      >
    </div>
    <Signature v-else @out="out" @keep="keep" />
    <van-overlay :show="shareshow" @click="shareshow = false">
      <div class="wrapper">
        <img src="../../assets/img/card/tips.jpg" class="shareimg" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { wxSocial, readRecord, getJsApiTicket} from "@/api/users";
import { noticedetail, noticesign,noticepreview } from "../../api/notice";
import { getToken } from "@/utils/auth";
import Signature from "../file/signature";
import { Dialog } from "vant";
import { loading, isAndroid } from "../../utils/index";
import wx from "weixin-js-sdk";
import { Overlay } from "vant";
import Vue from "vue";
Vue.use(Overlay);

export default {
  components: {
    Signature,
  },
  data() {
    return {
      data: {
        customerName: "",
        product: "",
        company: "",
      },
      show: true,
      signimg: "",
      customerId: "",
      cansign: "",
      keepalive: true,
      shareshow: false,
      href:''
    };
  },
  methods: {
    checkAuthor() {
      setTimeout(() => {
        if (!this.customerId && !getToken()) {
          WeixinJSBridge.call("closeWindow");
          document.addEventListener(
            "WeixinJSBridgeReady",
            function () {
              WeixinJSBridge.call("closeWindow");
            },
            false
          );
        }
      }, 5000);
      this.author();
    },
    author() {
      wxSocial({ requestUrl: this.$route.fullPath })
        .then((res) => {
          window.location.href = res;
          // window.location.href='www.baidu.com'
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 签名
    tosign() {
      Dialog.confirm({
        message: "是否进行签名",
      })
        .then(() => {
          // on confirm
          this.show = false;
        })
        .catch(() => {
          // on cancel
        });
    },
    // 取消签名
    out() {
      this.show = true;
    },
    keep(val) {
      this.show = true;
      this.signimg = val;
      sessionStorage.setItem("signimg", this.signimg); //保存签字
    },
    // 详情
    getdetail() {
      console.log(333);
      noticedetail(this.id)
        .then((res) => {
          this.data = { ...res };

          this.getwx();
        })
        .catch((err) => {
          if (err.response.data.status == 400) {
            if (this.cansign != 1) {
              setTimeout(() => {
                WeixinJSBridge.call("closeWindow");
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  function () {
                    WeixinJSBridge.call("closeWindow");
                  },
                  false
                );
              }, 2000);
            } else {
              sessionStorage.setItem("update", 1);
            }
          }
        });
    },
    // 预览
    topreview() {
       if (!this.signimg) {
        if (isAndroid()) {
          this.$router.push({ path: "/pdf2", query: { file: this.data.noticeFileUrl } });
        } else {
          window.open(this.data.noticeFileUrl);
        }
      } else {
        let { companyId, productId } = this.data;
        let data = {
          companyId,
          productId,
          signImgUrl: this.signimg,
        };
        loading(true);
        noticepreview(data).then((res) => {
          loading(false);
          this.data.noticeFileUrl = res;
          this.$router.push({ path: "/pdf2", query: { file:res } });
        });
      }
    },
    // 保存签名
    sign() {
      // if (!this.customerId && this.customerId == "null") {
      //   return;
      // }
      let issign = sessionStorage.getItem("issign");
      if (!this.signimg || issign != 1) {
        this.Toast("请先签名");
        return;
      }
      let data = {
        customerId: this.customerId,
        id: this.id,
        signImgUrl: this.signimg,
      };
      loading(true);
      noticesign(data).then(async (res) => {
        this.addrecord();
        loading(false);
        sessionStorage.removeItem("signimg"); //清除签字
        sessionStorage.removeItem('issign')
        await this.getdetail();
        this.keepalive = false;
        this.signimg=''
        sessionStorage.setItem("update", 1); //初始化缓存
      });
    },
    // 增加记录
    addrecord() {
      if (!this.customerId || this.customerId == "null" || getToken()) return;

      let time = new Date() * 1;
      let data = {
        customerId: this.customerId,
        duration: 1,
        userId: this.userId,
        type: "notice",
        enterTime: time,
        leaveTime: time,
      };
      this.startTime = time;
      readRecord(data)
        .then((res) => {})
        .catch((res) => {
          console.log(res);
        });
    },
    // 微信分享
    getwx() {
      let that = this;
      const link = window.location.href.split("?")[0];
      // if (link !== window.location.href) {
      // 	window.location.href = link;
      // } //为了兼容iOS系统，否则有可能地址取值出现错误
      const url = window.location.href.split("#")[0];
      getJsApiTicket({
        link: url,
      }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式
          appId: res.body.appid, // 必填，公众号的唯一标识
          timestamp: res.body.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
          signature: res.body.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            "updateTimelineShareData", //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          ], // 必填，需要使用的JS接口列表
        });
      });
      wx.ready(function () {
        that.wxShareTimeline();
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      });
      wx.error((res) => {
        console.warn("微信注册", res);
        // if(res.errMsg!='config:ok'){
        //   that.getwx()
        // }
      });
    },
    wxShareTimeline() {
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx.updateAppMessageShareData({
        title: "客户告知书在线签名", // 分享标题
        desc: this.data.product, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
          "https://zlx-resources.oss-cn-beijing.aliyuncs.com/erweima1613970886000.jpg", // 分享图标
        success: () => {
          console.log(1132);
        },
      });
      wx.updateTimelineShareData({
        title: "客户告知书在线签名", // 分享标题
        desc: this.data.product, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
          "https://zlx-resources.oss-cn-beijing.aliyuncs.com/erweima1613970886000.jpg", // 分享图标
        success: () => {},
      });
    },
    showimg() {
      this.shareshow = true;
    },
    
        onCopy(){
            this.$toast('成功复制到粘贴板')
        },
        onError(){
          this.$toast('复制失败，请刷新页面，稍后再试！')
        }
  },
  async mounted() {
    let { customerId, id, userId } = this.$route.query;
    this.href=window.location.href
    
    this.cansign = sessionStorage.getItem("cansign"); //签字保存按钮开关
    this.id = id;
    this.userId = userId;
    this.signimg = sessionStorage.getItem("signimg"); //获取保存的签字
    if (!customerId) {
      customerId = localStorage.getItem("customerId");
    } else {
      localStorage.setItem("customerId", customerId);
    }
    this.customerId = customerId;
    if (!customerId && !getToken()) {
      this.checkAuthor();
    } else if (customerId == "null" && !getToken()) {
      this.$router.push({ path: "/login" });
    } else {
      this.getdetail();
    }
  },
  // beforeRouteLeave (to, from, next) {
  //   console.log(to)
  //   if(this.keepalive==false){
  //      to.meta.keepAlive=false
  //   }else if(to.name=='notification'){
  //      to.meta.keepAlive=true
  //   }

  //   next()
  // }
};
</script>
<style lang="less" >
.unsign {
  width: 100%;
  .label {
    color: rgba(16, 16, 16, 100) !important;
    font-size: 14px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    text-align: right;
  }
  .block {
    width: 358px;
    margin: 19px auto;
    background: #fff;
    padding-bottom: 19px;
    padding-top: 10px;
    .pdf {
      color: rgba(51, 153, 255, 100);
      font-size: 14px;
      text-align: right;
      font-family: SourceHanSansSC-regular;
    }
    .signbtn {
      width: 54px;
      height: 21px;
      line-height: 21px;
      font-size: 11px;
      color: #fff;
      background: #c1cdd1;
      text-align: center;
      border-radius: 10px;
      margin-left: 16px;
    }
    .tosign {
      width: 66px;
      height: 21px;
      line-height: 21px;
      border-radius: 11px;
      background-color: rgba(51, 153, 255, 100);
      color: rgba(255, 255, 255, 100);
      font-size: 11px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(255, 255, 255, 100);
      margin-left: 40px;
    }
    .keep {
      height: 40px;
      margin: 14px auto;
      width: 338px;
    }
  }
  .bg59 {
    background: #59ba76 !important;
  }
  .bgc1 {
    background: #c1cdd1 !important;
  }
  .shareimg {
    width: 50%;
    float: right;
    margin-right: 10px;
  }
}
</style>